// extracted by mini-css-extract-plugin
export default {"wrapper":"kycPreview_wrapper__zLkDI","title":"kycPreview_title__5IEQr"};